import { useState, useEffect, useCallback } from "react";

const KEY = "gridiron-fav-team";
const EVT = "gridiron-fav-changed";

export function getFavorite() {
  return localStorage.getItem(KEY) || null;
}

export function useFavorite() {
  const [fav, setFav] = useState(getFavorite());

  useEffect(() => {
    const handler = () => setFav(getFavorite());
    window.addEventListener(EVT, handler);
    return () => window.removeEventListener(EVT, handler);
  }, []);

  const toggle = useCallback((abbr) => {
    const cur = getFavorite();
    if (cur === abbr) localStorage.removeItem(KEY);
    else localStorage.setItem(KEY, abbr);
    window.dispatchEvent(new Event(EVT));
  }, []);

  return { fav, toggle };
}
